import * as lib from 'Root/lib/lib.js'

class AnchorLinks {
    constructor(element) {
        if (!element) return

        this.element = element

        this.checkUrlAnchorLink()
        this.handleAnchorLinksClick()
    }

    checkUrlAnchorLink() {
        if (location.hash) {
            const targetEl = this.element.querySelector(location.hash)

            if (targetEl) {
                setTimeout(function () {
                    lib.moveWindowToObj($(targetEl))
                }, 1)
            }
        }
    }

    handleAnchorLinksClick() {
        $(this.element).on('click', 'a[href^="#"]', (e) => {
            const targetEl = this.element.querySelector(e.currentTarget.getAttribute('href'))

            if (targetEl) {
                lib.moveWindowToObj($(targetEl))
            }
        })
    }
}

export default AnchorLinks
